import { useFetchGet } from "hooks/fetch/useFetchGet";
import { makeQueryString } from "core/makeQueryString";
import { useMemo } from "react";
import isNil from "lodash/isNil";

export function useGetMachinesBySiteId(siteId, page = 1, pageSize = 10000) {
  const url = useMemo(
    () =>
      `machines${makeQueryString({
        page,
        site_id: siteId,
        size: pageSize
      })}`,
    [page, pageSize, siteId]
  );
  const { loading, error, response } = useFetchGet(url, isNil(siteId));

  return {
    loading,
    error,
    machines: response?.results
  };
}
